// @flow
import * as React from 'react';
import get from 'lodash/get';
import styles from './styles';

type Props = {
  item: Object,
  selected: boolean,
  onItemClick?: Function | boolean,
};

function DisambiguationItem({ item, selected, onItemClick }: Props) {
  return (
    <a href="#" onClick={onItemClick}>
      <li className="item">
        <span className={`circle ${selected ? 'selected' : ''}`}>
          {selected && <span className="circle-fill" />}
        </span>
        <strong>
          <span>{get(item, 'name')}</span>
        </strong>
      </li>
      <style jsx>{styles}</style>
    </a>
  );
}

DisambiguationItem.defaultProps = {
  onItemClick: false,
};

export default DisambiguationItem;



// WEBPACK FOOTER //
// ./app/common/Lists/DisambiguationList/item/index.js